import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Redirect, NavLink, withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withStyles } from "@material-ui/core/styles";
import CustomScrollbars from 'util/CustomScrollbars';
import Avatar from '@material-ui/core/Avatar';
import { RiExchangeFill } from "@react-icons/all-files/ri/RiExchangeFill";
import Drawer from '@material-ui/core/Drawer';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import { alternaCliente, alternarCliente, onChangeFilterClienteAlternar, fechaDrawerAlteranacao } from 'actions/Inicio';

const StyledCard = withStyles({
  root: {
    padding: 8,
    backgroundColor: 'red',
    border: '1px solid #F4F4F7',
    boxSizing: 'border-box',
    borderRadius: '8px',
    height: 56
  },
  "&.MuiCardHeader-root": {
    padding: 8,
    backgroundColor: 'yellow'
  },
})(Card);

const styles = theme => ({
  input: {
    fontSize: 19,
    fontWeight: 400,
    fontFamily: 'Montserrat, sans-serif',

    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "gray",
      fontSize: 20,
      lineHeight: 24,
      fontWeight: 400,
      fontFamily: 'Montserrat, sans-serif'
    },
  },

  root: {
    "&.MuiCardHeader-root": {
      padding: 8,
      backgroundColor: 'red'
    },
  }

});

class SidenavContent extends Component {
  constructor() {
    super();
    this.state = { alternarCliente: false }
  }

  /*   componentDidMount() {
      const { history } = this.props;
      const that = this;
      const pathname = `${history.location.pathname}`;// get current path
  
      const menuLi = document.getElementsByClassName('menu');
      for (let i = 0; i < menuLi.length; i++) {
        menuLi[i].onclick = function (event) {
  
          const parentLiEle = that.closest(this, 'li');
          if (menuLi[i].classList.contains('menu') && parentLiEle !== null) {
            event.stopPropagation();
  
            if (menuLi[i].classList.contains('open')) {
              menuLi[i].classList.remove('open', 'active');
            } else {
              menuLi[i].classList.add('open', 'active');
            }
          } else {
            for (let j = 0; j < menuLi.length; j++) {
              const parentLi = that.closest(this, 'li');
              if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
                menuLi[j].classList.remove('open');
              } else {
                if (menuLi[j].classList.contains('open')) {
                  menuLi[j].classList.remove('open');
                } else {
                  menuLi[j].classList.add('open');
                }
              }
            }
          }
        }
      }
  
      const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
      try {
        const activeNav = this.closest(activeLi, 'ul'); // select closest ul
        if (activeNav.classList.contains('sub-menu')) {
          this.closest(activeNav, 'li').classList.add('open');
        } else {
          this.closest(activeLi, 'li').classList.add('open');
        }
      } catch (error) {
  
      }
    } */

  handleTeste() {
    const { history } = this.props;
    const that = this;
    const pathname = `${history.location.pathname}`;// get current path

    const menuLi = document.getElementsByClassName('menu');
    for (let i = 0; i < menuLi.length; i++) {
      menuLi[i].onclick = function (event) {

        const parentLiEle = that.closest(this, 'li');
        if (menuLi[i].classList.contains('menu') && parentLiEle !== null) {
          event.stopPropagation();

          if (menuLi[i].classList.contains('open')) {
            menuLi[i].classList.remove('open', 'active');
          } else {
            menuLi[i].classList.add('open', 'active');
          }
        } else {
          for (let j = 0; j < menuLi.length; j++) {
            const parentLi = that.closest(this, 'li');
            if (menuLi[j] !== this && (parentLi === null || !parentLi.classList.contains('open'))) {
              menuLi[j].classList.remove('open');
            } else {
              if (menuLi[j].classList.contains('open')) {
                menuLi[j].classList.remove('open');
              } else {
                menuLi[j].classList.add('open');
              }
            }
          }
        }
      }
    }


    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  componentWillReceiveProps(nextProps) {
    const { history } = nextProps;
    const pathname = `${history.location.pathname}`;// get current path

    const activeLi = document.querySelector('a[href="' + pathname + '"]');// select current a element
    try {
      const activeNav = this.closest(activeLi, 'ul'); // select closest ul
      if (activeNav.classList.contains('sub-menu')) {
        this.closest(activeNav, 'li').classList.add('open');
      } else {
        this.closest(activeLi, 'li').classList.add('open');
      }
    } catch (error) {

    }
  }

  closest(el, selector) {
    try {
      let matchesFn;
      // find vendor prefix
      ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(function (fn) {
        if (typeof document.body[fn] === 'function') {
          matchesFn = fn;
          return true;
        }
        return false;
      });

      let parent;

      // traverse parents
      while (el) {
        parent = el.parentElement;
        if (parent && parent[matchesFn](selector)) {
          return parent;
        }
        el = parent;
      }
    } catch (e) {

    }

    return null;
  }


  handleAlternarCliente = (val) => {
    this.setState({ alternarCliente: val });
  }

  ObtemMenuUsuario = (configuracao) => {
    var menusRetorno = [];
    var itensRetorno = [];
    // Guardas para evitar erros quando configuracao ainda não foi reidratada.
    // Em modo "Educar" e "Dashboard", permitimos renderizar apenas com os menus,
    // mesmo que a lista de ações autorizadas ainda não esteja carregada.

    const ehEducar = this.props.moduloSelecionado === 'Educar';
    const ehDashboard = this.props.moduloSelecionado === 'Dashboard';
    const ehComunicacao = this.props.moduloSelecionado === 'Comunicação';

    if (
      !configuracao ||
      !Array.isArray(configuracao.menus) ||
      (
        !ehEducar &&
        !ehDashboard &&
        !ehComunicacao &&
        !Array.isArray(configuracao.listaConfiguracaoPortalFuncionalideAcao)
      )
    ) {
      return [];
    }

    var ehUzer = configuracao.uzerAcessoAmbienteCliente || configuracao.uzerAcessoPainelAdministrativo || configuracao.idPerfilSistema === 1;

    const verificarAutorizacaoEducar = (item) => {
      const path = String(item.path || '').toLowerCase();
      const desc = String(item.descricaoItem || '').toLowerCase();

      const isEscolasItem = path === 'escolas' || desc === 'escolas';
      const isAlunosItem = path === 'alunos' || desc === 'alunos';
      const isCursosItem = path === 'cursos' || desc === 'cursos';
      const isSeriesItem = path === 'series' || desc === 'séries' || desc === 'series';
      const isTurmasItem = path === 'turmas' || desc === 'turmas';
      const isDisciplinasItem = path === 'disciplinas' || desc === 'disciplinas';
      const isSeriesEscolaItem = path === 'series-escola' || desc === 'séries escola' || desc === 'series escola';
      
      const isAtividadesPedagogicasItem = path === 'atividades-pedagogicas' || desc === 'atividades pedagógicas' || desc === 'atividades pedagogicas' || desc === 'atividades';
      const isCalendariosItem = path === 'calendarios' || desc === 'calendários' || desc === 'calendarios' || desc === 'calendário';
      const isDiarioItem = path === 'diario' || desc === 'diário' || desc === 'diário escolar';
      const isNotasFaltasItem = path === 'notas-faltas' || desc === 'notas e faltas' || desc === 'notas faltas';
      const isRegrasAvaliacaoItem = path === 'regras-avaliacao' || desc === 'regras de avaliação' || desc === 'regras avaliação';

      const isAnoLetivoItem = path === 'anos-letivos' || desc === 'ano letivo' || desc === 'anos letivos';
      const isMatriculasItem = path === 'matriculas' || desc === 'matrículas' || desc === 'matriculas';
      const isRematriculaItem = path === 'rematricula' || desc === 'rematrícula' || desc === 'rematriculas';
      const isEnturmacaoSequencialItem = path === 'enturmacao-sequencial' || desc === 'enturmação sequencial' || desc === 'enturmacao sequencial';

      const isBoletimItem = path === 'boletim' || desc === 'boletim';
      const isMapaConselhoItem = path === 'mapa-conselho-classe' || desc === 'mapa conselho' || desc === 'mapa de conselho';

      const isEducacensoItem = path === 'educacenso-exportacao' || desc === 'educacenso' || desc === 'exportação' || desc === 'exportacao';
      const isRelatorioMalaItem = path === 'relatorio-mala' || desc === 'relatório mala direta' || desc === 'relatorio mala direta';
      const isRelatorioLancamentoItem = path === 'relatorio-lancamento' || desc === 'relatório lançamento' || desc === 'relatorio lancamento';

      return isEscolasItem || isAlunosItem || isCursosItem || isSeriesItem || isTurmasItem || isDisciplinasItem || isSeriesEscolaItem ||
             isAtividadesPedagogicasItem || isCalendariosItem || isDiarioItem || isNotasFaltasItem || isRegrasAvaliacaoItem ||
             isAnoLetivoItem || isMatriculasItem || isRematriculaItem || isEnturmacaoSequencialItem ||
             isBoletimItem || isMapaConselhoItem ||
             isEducacensoItem || isRelatorioMalaItem || isRelatorioLancamentoItem;
    };

    for (var indice in configuracao.menus) {
      var menu = configuracao.menus[indice];

      for (var indiceItem in menu.itensDoMenu) {
        var item = menu.itensDoMenu[indiceItem];
        var autorizado = ehEducar
          ? verificarAutorizacaoEducar(item)
          : configuracao.listaConfiguracaoPortalFuncionalideAcao.filter(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.idItemMenu === item.id).length > 0;

        if (autorizado && menusRetorno.filter(x => x.id === item.idMenuSistema).length === 0) {
          // Clonamos o menu e seus itens para evitar mutar o estado global/redux
          menusRetorno.push({
            ...menu,
            itensDoMenu: (menu.itensDoMenu || []).map(i => ({ ...i }))
          });
        }
      }
    }

    for (let i in menusRetorno) {
      var menu = menusRetorno[i];
      itensRetorno = [];

      const ehMenuDashboard = String(menu.descricaoMenu || '') === 'Dashboard';
      const ehMenuComunicacao = String(menu.descricaoMenu || '') === 'Comunicação';

      for (let j in menu.itensDoMenu) {
        var item = menu.itensDoMenu[j];

        const path = String(item.path || '').toLowerCase();

        const autorizado =
          ehEducar
            ? verificarAutorizacaoEducar(item)
            : ehDashboard
              ? ehMenuDashboard
              : ehComunicacao
                ? ehMenuComunicacao
                : configuracao.listaConfiguracaoPortalFuncionalideAcao
                  .some(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.idItemMenu === item.id);

        if (autorizado) {

          if (!ehUzer && item.descricaoItem === 'Clientes') {
            item.descricaoItem = 'Meu negócio';
            item.rota = 'routes/clientes/indexClienteFixo';
          }

          // Restringe submenus específicos de relatórios apenas para o módulo Educar
          if (!ehEducar && (path === 'relatorio-lancamento' || path === 'relatorio-mala' || path === 'educacenso-exportacao')) {
            // Se não for Educar, pula a adição desses itens
          } else {
            itensRetorno.push(item);
          }
        }
      }


      menu.itensDoMenu = itensRetorno;
    }


    /*     if (menuLancamento) {
            const jaExiste = menuLancamento.itensDoMenu.some(i => i.rota === 'routes/atividades-pedagogicas/index');
            if (!jaExiste) {
                menuLancamento.itensDoMenu.push({
                    id: 99999, // ID fictício para garantir unicidade
                    descricaoItem: 'Atividades Pedagógicas',
                    rota: 'routes/atividades-pedagogicas/index',
                    icone: 'zmdi-assignment',
                    idMenuSistema: menuLancamento.id
                });
            }
        } */


    // Em alguns perfis (Uzer), um menu extra é adicionado. Evite inserir menus inválidos
    // e não inserir quando o módulo selecionado for "Educar" (menu deve ficar restrito).
    if (ehUzer && menusRetorno.length !== 0) {
      const extraMenu = (configuracao.menus || [])[5];
      const isValidExtra = extraMenu && Array.isArray(extraMenu.itensDoMenu) && extraMenu.itensDoMenu.length > 0;
      const jaExisteMesmoTitulo = isValidExtra && menusRetorno.some(m => String(m.descricaoMenu || '').toLowerCase() === String(extraMenu.descricaoMenu || '').toLowerCase());
      if (isValidExtra && this.props.moduloSelecionado !== 'Educar' && !jaExisteMesmoTitulo) {
        menusRetorno.push({
          ...extraMenu,
          itensDoMenu: (extraMenu.itensDoMenu || []).map(i => ({ ...i }))
        });
      }
    }

    const maxMenuOrder = menusRetorno.reduce((acc, m) => {
      const v = Number(m.ordem);
      return isNaN(v) ? acc : Math.max(acc, v);
    }, 0);

    // Filtro: os menus "Cadastros", "Anos letivos" e "Movimentação" devem aparecer
    // SOMENTE quando o módulo "Educar" (Gestão Escolar) estiver selecionado.
    // Quando outro módulo estiver ativo, esses menus são removidos do sidebar.
    if (!ehEducar) {
      const menusExclusivoEducar = ['cadastros', 'anos letivos', 'lançamentos', 'lancamentos', 'documentos'];
      menusRetorno = menusRetorno.filter(m => {
        const tituloMenu = String(m.descricaoMenu || '').toLowerCase();
        return !menusExclusivoEducar.includes(tituloMenu);
      });
    } else {
      // Força a ordem exata exigida para o módulo de Gestão Escolar para evitar conflitos na propriedade "ordem"
      menusRetorno.forEach(m => {
        const tituloMenu = String(m.descricaoMenu || '').toLowerCase();
        if (tituloMenu === 'cadastros') m.ordem = 1;
        if (tituloMenu === 'lançamentos' || tituloMenu === 'lancamentos') m.ordem = 2;
        if (tituloMenu === 'anos letivos') m.ordem = 3;
        if (tituloMenu === 'documentos') m.ordem = 4;
        if (tituloMenu === 'relatórios' || tituloMenu === 'relatorios') m.ordem = 5;
        if (tituloMenu === 'educacenso') m.ordem = 6;
      });
    }

    // Remove menus duplicados (mantém o primeiro por título)
    const menusTitulosVistos = new Set();
    menusRetorno = menusRetorno.filter(m => {
      const titulo = String(m.descricaoMenu || '').toLowerCase();
      if (menusTitulosVistos.has(titulo)) {
        return false;
      }
      menusTitulosVistos.add(titulo);
      return true;
    });

    this.handleTeste()
    return menusRetorno;
  }


  render() {

    const inicio = this.props.inicio;
    var configuracao = this.props.configuracao !== undefined ? this.props.configuracao : {};
    var adm = configuracao.uzerAcessoAmbienteCliente || configuracao.uzerAcessoPainelAdministrativo || configuracao.idPerfilSistema === 1 || configuracao.idUsuarioSistema === 1
    var ehMulti = configuracao.ehMulti;
    var menuRenderizar = this.ObtemMenuUsuario(configuracao);
    var imagemTratadaCliente = "";
    const listaClientes = adm ? inicio.listaResultadosPesquisaClientes : inicio.listaDeClientesDoUsuario;

    var listaClientesExibicaoParaAlternar = listaClientes.sort((a, b) => b - a).slice(0, 4);
    const clienteFixo = inicio.nomeClienteFixado !== "" && inicio.nomeClienteFixado !== undefined && inicio.nomeClienteFixado !== null;
    var imagemTratada = inicio.imgClienteFixado;
    imagemTratada = imagemTratada !== null && imagemTratada !== "" && imagemTratada !== undefined ? imagemTratada.substr(imagemTratada.indexOf(",") + 1) : null;
    const alternarCliente = inicio.alternarCliente;
    const { classes } = this.props;

    return (
      <CustomScrollbars className=" scrollbar">

        {
          (clienteFixo) && (

            imagemTratada !== null ?
              <NavLink to="/app/inicio">
                <Avatar variant='square' style={{ width: 200, height: 200, marginLeft: 'auto', marginRight: 'auto', marginTop: 15 }} src={`data:image/jpeg;base64,${imagemTratada}`} />
              </NavLink>
              :
              <NavLink to="/app/inicio">
                <Avatar variant='rounded' style={{ width: 250, height: 200 }} src={require("assets/images/no-image.jpg")} />
              </NavLink>
          )}


        <div style={{ color: '#222224', textAlign: 'center', width: '100%', paddingLeft: 10, paddingRight: 10, paddingTop: 5, fontWeight: 500, fontFamily: 'Montserrat, sans-serif' }}>{inicio.nomeClienteFixado}</div>

        {
          (adm || ehMulti) &&
          (
            <NavLink to="/app/inicio">
              <div onClick={() => this.props.alternaCliente()} style={{ textAlign: 'center', width: '100%', fontFamily: 'Montserrat, sans-serif' }}>
                {/* <a  style={{ cursor: 'pointer', color: '#05B59D', fontFamily: 'Montserrat, sans-serif', fontSize: '14px', fontWeight: 400 }}> */}alternar{/* </a> */}
              </div>
            </NavLink>
          )
        }

        <Drawer anchor="left" open={alternarCliente} onClose={() => this.props.fechaDrawerAlteranacao()}>

          {
            (clienteFixo) && (

              imagemTratada !== null ?

                <Avatar variant='square' style={{ width: 200, height: 200, marginLeft: 'auto', marginRight: 'auto', marginTop: 15 }} src={`data:image/jpeg;base64,${imagemTratada}`} />
                :
                <Avatar variant='rounded' style={{ width: 250, height: 200 }} src={require("assets/images/no-image.jpg")} />
            )
          }

          {
            <Fragment>
              <div style={{ color: '#222224', textAlign: 'center', width: '375px', fontWeight: 500, paddingLeft: 10, paddingRight: 10, paddingTop: 5, fontFamily: 'Montserrat, sans-serif' }}>{inicio.nomeClienteFixado}</div>

              <Divider style={{ marginBottom: 15, marginTop: 10 }} light />


              <div style={{ paddingLeft: 20, paddingRight: 20 }}>
                <div style={{ color: '#3A3A3D', fontWeight: 400, fontSize: '16px', fontFamily: 'Montserrat, sans-serif', letterSpacing: '0.15px' }}>Selecione um cliente</div>
                <TextField
                  variant="filled"
                  placeholder="Pesquisar..."
                  value={this.props.textoFiltroClienteAlternar}
                  onChange={this.props.onChangeFilterClienteAlternar}
                  margin="normal"
                  fullWidth={true}
                  style={{ lineHeight: '24px', marginTop: '10px', marginBottom: '10px', backgroundColor: '#00000000' }}
                  InputProps={{
                    classes: {
                      input: classes.input
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )
                  }}
                />

                {
                  listaClientesExibicaoParaAlternar.map(n => {

                    imagemTratadaCliente = n.imagem;
                    imagemTratadaCliente = imagemTratadaCliente !== null && imagemTratadaCliente !== "" && imagemTratadaCliente !== undefined ? imagemTratadaCliente.substr(imagemTratadaCliente.indexOf(",") + 1) : null;

                    return (<Fragment key={`key${n.id}`}>
                      <div onClick={() => { this.props.alternarCliente(n.id); }} style={{ cursor: 'pointer' }}>
                        <Card style={{ border: '1px solid #F4F4F7', boxSizing: 'border-box', borderRadius: '8px', height: 56, marginBottom: 10 }}>
                          <CardHeader style={{ padding: 8 }}
                            avatar={
                              imagemTratadaCliente !== null ?
                                <Avatar style={{ width: 40, height: 40 }} src={`data:image/jpeg;base64,${imagemTratadaCliente}`} /> :
                                <Avatar style={{ width: 40, height: 40 }} src={require("assets/images/no-image.jpg")} />
                            }
                            action={
                              <ChevronRightIcon style={{ marginTop: 17, color: '#3A3A3D' }} />
                            }
                            title={n.nomeRazaoSocial}
                          ///subheader="September 14, 2016"
                          />
                        </Card>
                      </div>
                    </Fragment>);
                  })}
              </div>

            </Fragment>
          }


        </Drawer>

        <ul className="nav-menu">

          <li className="nav-header">
            <div>
              Principal
            </div>
          </li>

          {
            menuRenderizar.sort((a, b) => Number(a.ordem) - Number(b.ordem)).map(menu => {

              return (
                <li key={`key${menu.id}`} className="menu collapse-box ">

                  <Button>
                    <i className="zmdi zmdi-compass zmdi-hc-fw" />
                    <span style={{ fontWeight: 'bold', fontFamily: 'Montserrat, sans-serif', fontSize: '14px' }} className="nav-text">
                      {menu.descricaoMenu}
                    </span>
                  </Button>

                  <ul className="sub-menu">

                    {
                      menu.itensDoMenu.sort((a, b) => {
                        return Number(a.ordem) - Number(b.ordem);
                      }).map(item => {
                        return (
                          <li key={`key${item.id}`}>
                            <NavLink className="prepend-icon" to={`/app/${item.path}`}>
                              <span style={{ fontWeight: 500 }} className="nav-text text-transform-none">{item.descricaoItem}</span>
                            </NavLink>
                          </li>
                        )
                      })
                    }

                  </ul>
                </li>
              )

            })
          }

        </ul>
      </CustomScrollbars>
    );
  }
}

SidenavContent.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = ({ inicio, auth, settings }) => {
  const { perfil } = auth;
  const { configuracao, moduloSelecionado } = settings
  return { inicio, perfil, configuracao, moduloSelecionado };
};

export default connect(mapStateToProps, { alternaCliente, alternarCliente, onChangeFilterClienteAlternar, fechaDrawerAlteranacao })(withRouter(withStyles(styles)(SidenavContent)));
